<template>
    <div class="w-full h-full pb-4">
        <div
            ref="el"
            class="hover:shadow-lg rounded-lg w-full h-full"
            :class="[
                ['hero', 'teaser', 'teaser-image', 'recipe'].indexOf(cardType) >= 0 ? 'p-3' : 'p-4 hover:bg-base-200 bg-base-200 md:bg-transparent',
                getCardBgClass,
                cardType == 'teaser' ? 'bg-white' : '',
            ]"
        >
            <component :is="component" :config="config" :is-first="isFirst" />
        </div>
    </div>
</template>

<script setup lang="ts">
import type { HblSlot } from '@/utils/types'
import {computed, shallowRef, defineAsyncComponent} from 'vue'
import { hblToUpperCamelCase } from '@/utils/helper'

const props = defineProps<{
    config: HblSlot,
    cardType: string
    isFirst?: boolean
}>()

const component = shallowRef()

const compName = computed(() => {
    return `${hblToUpperCamelCase(props.cardType)}`
})

const loadComponent = function () {
    component.value = defineAsyncComponent({
        // the loader function
        loader: () => import(`./type/${compName.value}.vue`)
    })
}

const getCardBgClass = computed(() => {
    if (props.cardType === 'hero') {
        // @ts-ignore
        const variant = props.config?.config?.variant?.value || 'variant1'

        switch (variant) {
        case 'variant2':
            return 'bg-sale'
        case 'variant3':
        case 'variant1':
        default:
            return 'bg-base-200'
        }
    }

    return 'md:bg-white'
})

loadComponent()
</script>